import { createAction, handleActions } from 'redux-actions';

// 타입 정의
export const TOGGLE_DRAWER = 'drawer/TOGGLE';
export const SET_LANGUAGE = 'SET_LANGUAGE';

// 액션 내보내기
export const toggleDrawer = createAction(TOGGLE_DRAWER);
export const setLanguage = createAction(SET_LANGUAGE);

function getDefaultLang() {
  const browserLang = (navigator.language || navigator.userLanguage).split(
    '-'
  )[0];
  const supportedLang = ['ko', 'en', 'zh'];
  const fallbackLang = 'en';

  return supportedLang.indexOf(browserLang) > -1 ? browserLang : fallbackLang;
}
// 초기 상태값
const initialState = {
  language: localStorage.getItem('lang') || getDefaultLang(),
  isDrawerOpen: false
};

// 리듀서 내보내기
export default handleActions(
  {
    [TOGGLE_DRAWER]: state => {
      return { ...state, isDrawerOpen: !state.isDrawerOpen };
    },
    [SET_LANGUAGE]: (state, { payload }) => {
      localStorage.setItem('lang', payload);
      return { ...state, language: payload };
    }
  },
  initialState
);
